import { render, staticRenderFns } from "./StatisticsOccupation.vue?vue&type=template&id=9af53be4"
import script from "./StatisticsOccupation.vue?vue&type=script&lang=js"
export * from "./StatisticsOccupation.vue?vue&type=script&lang=js"
import style0 from "./StatisticsOccupation.vue?vue&type=style&index=0&id=9af53be4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports